import { Router } from 'pjax';
import fastStart from './fast-start.js';

Router.get('judging/fast-start', fastStart);
